export default "__VITE_ASSET__Td1mOwLQ__"